import React, { Component } from 'react';
import { Container, Row, Col, Input, Table, Button } from 'reactstrap';
import { Typeahead } from 'react-bootstrap-typeahead';
import authService from '../api-authorization/AuthorizeService';
import AdminFunctions from './AdminFunctions';
import utilities from '../util/utilities';
import { FaSort } from 'react-icons/fa'
import '../layout/site.css';

export class Clients extends Component {
    static displayName = Clients.name;

    constructor(props) {
        super(props);

        this.state = {
            search: null,
            clients: [],
            height: 0,
            width: 0,
            sort: {
                column: null,
                direction: 'desc'
            },
        };

        window.addEventListener('resize', this.setWindowDimensions);        
    }

    async componentDidMount() {
        const isAdmin = AdminFunctions.isAdminAsync();
        if(!isAdmin) {
            this.props.history.push('/accessdenied');
        }
        this.setWindowDimensions();
        this.getClients();        
    }

    render() {
        return (
            <div>
                <Container className='container-main'>
                    <Row>
                        <Col>
                            <h3>Clients</h3>
                        </Col>
                    </Row>
                    <Row className='row-20'>
                        <Col xl='10' lg='10' md='12' sm='12' xs='12'>
                            <Input
                                type='text'
                                onChange={(e) => this.setState({ search: e.target.value })}
                                name='search'
                                id='search'
                                placeholder='Search'
                                style={ this.state.width < utilities.dimensions.LG ? { marginBottom: '20px' } : {}}
                            />
                        </Col>
                        <Col xl='1' lg='1' md='2' sm='2' xs='2'>
                            <Button
                                color='primary'
                                onClick={() => this.searchClients()}
                            >
                                Search
                            </Button>
                        </Col>
                        <Col xl='1' lg='1' md='2' sm='2' xs='2'>
                            <Button
                                color='primary'
                                onClick={() => this.props.history.push('/admin/clients/create')}
                            >
                                + Add
                            </Button>
                        </Col>
                    </Row>
                    <Row className='row-20'>
                        <Col>
                            <Table bordered hover>
                                <thead>
                                    <tr>
                                        <th>
                                            Id               
                                            <FaSort
                                                color={this.state.sort.column === 'id' ? '#0a58ca' : 'black'}
                                                onClick={() => this.handleSort('id')}
                                                className='sort-button'
                                            />                             
                                        </th>
                                        <th>
                                            Name
                                            <FaSort
                                                color={this.state.sort.column === 'name' ? '#0a58ca' : 'black'}
                                                onClick={() => this.handleSort('name')}
                                                className='sort-button'
                                            />
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.clients.map((client,  i) => {
                                        return (
                                            <tr
                                                key={client.id}
                                                onClick={() => this.handleRowClick(client.id)}
                                            >
                                                <td>{client.id}</td>
                                                <td>{client.name}</td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>                    
                </Container>
            </div>
        )
    }

    async getClients() {
        const token = await authService.getAccessToken();
        const response = await fetch(`api/Clients/GetClients`, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`}
        });
        const data = await response.json();
        this.setState({ clients: data });
    }

    async searchClients() {
        const token = await authService.getAccessToken();
        const response = await fetch(`api/Clients/SearchClients?query=${this.state.search}`, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`}
        });
        const data = await response.json();
        this.setState({ clients: data });
    }

    handleRowClick(clientId) {
        this.props.history.push({
            pathname: '/admin/clients/details',
            state: { clientId: clientId, existingClient: true }
        });
    }

    setWindowDimensions = () => {
        this.setState({
            height: window.innerHeight,
            width: window.innerWidth
        });
    };

    // table sort

    handleSort(column) {
        const direction = this.state.sort.column ? (this.state.sort.direction === 'asc' ? 'desc' : 'asc') : 'desc';
        const data = this.state.clients;
        data.sort((a, b) => a[column].toString().localeCompare(b[column].toString()))
        if(direction === 'desc') {
            data.reverse();
        }
        this.setState({
            clients : data,
            sort: {
                column,
                direction
            }
        })
    };
}